var _rect, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgSol = function SvgSol(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "#000",
    rx: 12
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "m18.927 15.461-2.311 2.375a.537.537 0 0 1-.392.164H5.27a.277.277 0 0 1-.148-.042.26.26 0 0 1-.099-.112.248.248 0 0 1 .05-.279l2.308-2.374a.535.535 0 0 1 .391-.164h10.956a.275.275 0 0 1 .15.04.26.26 0 0 1 .1.112.247.247 0 0 1-.05.28Zm-2.311-4.784a.542.542 0 0 0-.392-.163H5.27a.276.276 0 0 0-.148.042.26.26 0 0 0-.099.112.248.248 0 0 0 .05.278l2.308 2.377a.539.539 0 0 0 .391.163h10.956a.278.278 0 0 0 .147-.042.262.262 0 0 0 .098-.113.248.248 0 0 0-.05-.277l-2.306-2.377ZM5.269 8.972h10.955a.555.555 0 0 0 .392-.163l2.31-2.375a.256.256 0 0 0 .072-.208.251.251 0 0 0-.122-.185.276.276 0 0 0-.149-.04H7.771a.555.555 0 0 0-.39.164L5.07 8.539a.248.248 0 0 0-.05.278.26.26 0 0 0 .1.112.277.277 0 0 0 .148.042Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 6.181,
    x2: 17.126,
    y1: 18.286,
    y2: 5.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.08,
    stopColor: "#9945FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3,
    stopColor: "#8752F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#5497D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#43B4CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72,
    stopColor: "#28E0B9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.97,
    stopColor: "#19FB9B"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgSol);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "sol.a03f5c95b3fe50efd268b750f568eda0.svg";